import React from 'react';
import { MingaIcon } from './MingaLogo';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100 py-12 px-6" data-id="element-61">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-62">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-63">
          <MingaIcon size={24} data-id="element-64" />
          MINGA
        </div>

        <div className="flex items-center gap-6 text-sm text-gray-500 font-medium" data-id="element-65">
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-66">
            Términos
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-67">
            Privacidad
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-68">
            Contacto
          </a>
        </div>

        <div className="text-sm text-gray-400" data-id="element-69">
          © {new Date().getFullYear()} MINGA. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}